import axiosClient from "../../../shared/lib/axiosClient";
import { COURSE_API_BASE } from "../../../shared/utils/apiConfig";
import type { CourseStructure, CourseStructureResponse } from "../types";

// Sections and lessons of a course the user is enrolled in
export const getCourseStructure = async (
    courseId: string,
    signal?: AbortSignal
): Promise<CourseStructure> => {
    const { data } = await axiosClient.get<CourseStructureResponse>(
        `${COURSE_API_BASE}/${courseId}/structure`,
        { signal }
    );

    // The server's message is shown to the user, so pass it along
    if (!data.success || !data.course?.course) throw new Error(data.message ?? "");

    return data.course.course;
};

import type {
    CompleteAttemptPayload,
    CompleteAttemptResponse,
    ContentItem,
    ContentResponse,
    StartAttemptResponse
} from "../lessonTypes";

type Id = number | string;

// One lesson / project / video of a course
export const getContentItem = async (
    courseId: string,
    contentId: string,
    language: string,
    signal?: AbortSignal
): Promise<ContentItem> => {
    const { data } = await axiosClient.get<ContentResponse>(
        `${COURSE_API_BASE}/${courseId}/content/${contentId}`,
        { params: { language }, signal }
    );

    const row = data.course.content;
    return { content: row.content ?? {}, alreadyCompleted: Boolean(row.already_completed) };
};

// Opens a tracked attempt of a lesson and returns its id
export const startLessonAttempt = async (
    userId: Id,
    payload: { session_id?: string; content_id: string }
): Promise<number | string> => {
    const { data } = await axiosClient.post<StartAttemptResponse>(
        `${COURSE_API_BASE}/${userId}/lesson-attempt`,
        payload
    );
    return data.lesson_attempt_id;
};

// Saves the result of an attempt: the server answers with the rewards
export const completeLessonAttempt = async (
    userId: Id,
    attemptId: Id,
    payload: CompleteAttemptPayload
): Promise<CompleteAttemptResponse> => {
    const { data } = await axiosClient.put<CompleteAttemptResponse>(
        `${COURSE_API_BASE}/${userId}/lesson-attempt/${attemptId}/complete`,
        payload
    );
    return data;
};